/**
 * CAS 検索アプリ
 * 親クラス ./CcSearch
 */

import $ from 'jquery';
import { lang } from '../module/Global';
import CcSearch from './CcSearch';
import Slide from './Slide';
import Filter from './Filter';

class PmSearch extends CcSearch {
	constructor(root) {
		super(root);
		this.thumbs = {};
	}

	/**
	 * 初期処理
	 */
	init() {
		this.slide = new Slide('pm', $('.selected-area'), {
			prev: $('.selected-area__arw--left'),
			next: $('.selected-area__arw--right')
		});
		this.$form.val('');
		this.getData();
		this.addListeners();
	}

	/**
	 * jsonデータ取得
	 */
	getData() {
		let url = './load_products.html';
		let option = { method: 'POST', credentials: 'include' };

		if (
			location.host === 'chemrest.localhost' ||
			location.host === 'localhost' ||
			location.hash.indexOf('mode=develop') > -1
		) {
			url = '/_develop/product.json';
			option = { method: 'GET' };
		}

		fetch(url, option)
			.then(res => {
				return res.json();
			})
			.then(this.loadData.bind(this));
	}

	/**
	 * json読み込み完了
	 */
	loadData(json) {
		this.data = json.data;
		this.filter = new Filter(this.data, ['product_name', 'product_code']);

		// サムネイルデータ格納
		for (let i = 0, l = this.data.length; i < l; i++) {
			const code = this.data[i].product_code;
			this.thumbs[code.replace(/\s/g, '')] = this.data[i].product_image;
		}

		this.domCreate(this.data);
	}

	/**
	 * item_dataからDOMを作成追加
	 */
	domCreate(item_data) {
		const selected_data = this.slide.getSetData();

		// 更地に
		this.$list.empty();

		// アイテム作成
		let items = '';
		for (let i = 0, l = item_data.length; i < l; i++) {
			let cls = 'app-item app-item--pm';
			let material_txt = 'MATERIAL';
			let length_txt = 'LENGTH';
			if (lang === 'it') {
				material_txt = 'MATERIALE';
				length_txt = 'LUNGHEZZA';
			} else if (lang === 'fr') {
				material_txt = 'COMPOSANTS';
				length_txt = 'LONGUEUR';
			} else if (lang === 'es') {
				length_txt = 'LONGITUD';
			} else if (lang === 'nl') {
				material_txt = 'MATERIAAL';
				length_txt = 'LENGTE';
			} else if (lang === 'de') {
				length_txt = 'LÄNGE';
			} else if (lang === 'ja') {
				material_txt = '素材';
				length_txt = '全長';
			}

			for (let j = 0, k = selected_data.length; j < k; j++) {
				if (item_data[i].product_code === String(selected_data[j]))
					cls += ' app-item--selected';
			}

			if (item_data[i].product_name === void 0) {
				item_data[i].product_name = '';
			}

			items += `
				<li class="${cls}" data-number="${item_data[i].product_code}">
					<div class="app-item__inr">
						<div class="app-item__top"><img src="${
							item_data[i].product_image
						}" alt="" class="app-item__top__img"></div>
						<div class="app-item__bottom">
							<p class="app-item__name">${item_data[i].product_name}</p>
							<p class="app-item__number">${item_data[i].product_code}</p>
							<p class="app-item__prop">
								<span class="app-item__prop__key">${material_txt}</span>
								<span class="app-item__prop__val">${item_data[i].material}</span>
							</p>
							<p class="app-item__prop">
								<span class="app-item__prop__key">${length_txt}</span>
								<span class="app-item__prop__val">${item_data[i].length_inch} in. / ${
				item_data[i].length_mm
			}mm</span>
							</p>
						</div>
					</div>
				</li>
			`;
		}

		// flexのスペースアイテムを多めに追加
		for (let i = 0; i < 12; i++) {
			items += `<li class="app-item app-item--space app-item--pm"><div class="app-item__inr"></div></li>`;
		}

		this.$list[0].insertAdjacentHTML('afterbegin', items);

		this.memberUpdate();
	}

	/**
	 * 検索ボタンのトラッキング
	 */
	tracking(e) {
		const $_this = $(e.currentTarget);

		if ($_this.attr('href').indexOf('javascript') < 0) {
			const set_data = this.slide.getSetData();
			for (let i = 0, l = set_data.length; i < l; i++) {
				gtag('event', 'search', {
					event_category: 'PRODUCT_SEARCH',
					event_label: set_data[i]
				});
			}
		}
	}

	/**
	 * アイテムのクリック処理
	 * @param {*} e
	 */
	itemClick(e) {
		const _this = $(e.currentTarget);
		const data = _this.data();
		let is_add = false;
		let is_limit = false;

		if (_this.hasClass('app-item--space')) return;

		_this.toggleClass('app-item--selected');

		is_add = _this.hasClass('app-item--selected') ? true : false;
		is_limit = this.slide.getSetData().length >= 6 ? true : false;

		if (is_limit && is_add) {
			_this.removeClass('app-item--selected');
			this.$toast.addClass('app-toast--show');
			clearTimeout(this.toast_timer);
			this.toast_timer = setTimeout($.proxy(this.toastHide, this), 2500);
		}

		for (let i = 0, l = this.$item.length; i < l; i++) {
			const current = this.$item.eq(i);

			if (current.data().number === data.number) {
				if (is_add) {
					if (!is_limit) current.addClass('app-item--selected');
				} else {
					current.removeClass('app-item--selected');
				}
			}
		}

		if (_this.hasClass('app-item--selected')) {
			if (!is_limit) this.slide.addList(data.number);
		} else {
			this.slide.deleteList(data.number);
		}

		const set_data = this.slide.getSetData();
		this.param_url = '../result/?';
		for (let i = 0, l = set_data.length; i < l; i++) {
			this.param_url += `product_code[]=${set_data[i]}&`;
		}
		this.$search_btn.attr('href', this.param_url);

		this.slide
			.getDom()
			.find('img')
			.each((i, val) => {
				$(val).attr(
					'src',
					this.thumbs[
						$(val)
							.attr('data-src')
							.replace(/\s/g, '')
					]
				);
			});
	}

	/**
	 * 選択済み削除
	 * @param {*} e
	 */
	selectDelete(e) {
		super.selectDelete(e);

		this.slide
			.getDom()
			.find('img')
			.each((i, val) => {
				$(val).attr(
					'src',
					this.thumbs[
						$(val)
							.attr('data-src')
							.replace(/\s/g, '')
					]
				);
			});
	}
}

export default PmSearch;



// WEBPACK FOOTER //
// ./src/js/app/PmSearch.js